import {
  CustomField,
  CustomFieldDataType,
  SubscriptionFormCustomField,
} from 'common/types';

import BooleanInput from './inputs/BooleanInput';
import CountryInput from './inputs/CountryInput';
import DateInput from './inputs/DateInput';
import Input from './inputs/Input';
import MultiSelectInput from './inputs/MultiSelectInput';
import SingleSelectInput from './inputs/SingleSelectInput';

interface CustomFieldInputProps {
  field: SubscriptionFormCustomField;
  fieldDefinition: CustomField;
  value: any;
  error?: string;
  onChange: (value: any) => void;
  disabled?: boolean;
}

function CustomFieldInput({
  field,
  fieldDefinition,
  value,
  error,
  onChange,
  disabled = false,
}: CustomFieldInputProps) {
  const label = field.displayLabel || fieldDefinition.displayName;
  const placeholder = field.placeholder || fieldDefinition.displayName;
  const errorMessage = error || field.errorMessage;

  switch (fieldDefinition.dataType) {
    case CustomFieldDataType.STRING:
    case CustomFieldDataType.NUMBER:
      return (
        <Input
          label={label}
          placeholder={placeholder}
          value={value}
          error={errorMessage}
          onChange={onChange}
          disabled={disabled}
          isMandatory={field.isMandatory}
          type={fieldDefinition.dataType === 'NUMBER' ? 'number' : 'text'}
        />
      );

    case CustomFieldDataType.DATE:
      return (
        <DateInput
          label={label}
          placeholder={placeholder}
          value={value}
          error={errorMessage}
          onChange={onChange}
          disabled={disabled}
          isMandatory={field.isMandatory}
        />
      );

    case CustomFieldDataType.BOOLEAN:
      return (
        <BooleanInput
          label={label}
          placeholder={placeholder}
          value={value}
          error={errorMessage}
          onChange={onChange}
          disabled={disabled}
          isMandatory={field.isMandatory}
        />
      );

    case CustomFieldDataType.SINGLE_SELECT:
      return (
        <SingleSelectInput
          label={label}
          placeholder={placeholder}
          value={value}
          error={errorMessage}
          onChange={onChange}
          disabled={disabled}
          isMandatory={field.isMandatory}
          options={fieldDefinition.constraint?.values || []}
        />
      );

    case CustomFieldDataType.MULTI_SELECT:
    case CustomFieldDataType.SET_STRING:
      return (
        <MultiSelectInput
          label={label}
          value={value}
          error={errorMessage}
          onChange={onChange}
          disabled={disabled}
          isMandatory={field.isMandatory}
          options={fieldDefinition.constraint?.values || []}
        />
      );

    case CustomFieldDataType.COUNTRY:
      return (
        <CountryInput
          label={label}
          placeholder={placeholder}
          value={value}
          error={errorMessage}
          onChange={onChange}
          disabled={disabled}
          isMandatory={field.isMandatory}
        />
      );

    default:
      console.warn(`Unsupported field type: ${fieldDefinition.dataType}`);
      return null;
  }
}

export default CustomFieldInput;
